/*
 * Mountain Dog Products — Leash Finder quiz (logic).
 * Loaded by snippets/quiz-leash-finder.liquid, which also emits window.MDP_QUIZ_DATA
 * (colours, prices, images, availability read from the live catalogue at render time).
 * Nothing about the catalogue is hand-maintained in this file.
 */
(function () {
  var D = window.MDP_QUIZ_DATA;
  if (!D || !D.catalog) return;

  /* ── CONFIG ──────────────────────────────────────────────────────────── */
  var KV_KEY  = "Vq3dAE";        // Klaviyo public API key (company id)
  var KV_LIST = "R5jKab";        // Klaviyo list: DC | Quiz Completed
  var BASE    = "/products/";
  var TRACKING = { meta: true, ga4: true };
  var AUTO_ADVANCE_MS = 380;

  var PH_IMG = "data:image/svg+xml;charset=utf8," + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300"><rect width="100%" height="100%" fill="#EDE9E1"/></svg>');

  /* Swatch fills: the same hex map as the leash PDP (sections/mdp-leash-hero.liquid),
   * two-tone ropes as the PDP's 50/50 two-stop gradient. Keep the two in step.
   * A colour with no entry renders its own variant photo instead. */
  function two(a, b) { return "linear-gradient(90deg," + a + " 50%," + b + " 50%)"; }
  var HEX = {
    "Labrador Lapis":        two("#083EA3", "#9FC3F0"),
    "Magnificent Mutt Neon": "#43CA93",
    "Akita Azure":           "#1731A5",
    "Boxer Blonde":          "#F4D24F",
    "Canine Cranberry":      "#CD3F3C",
    "Firestorm Blue":        two("#1B3A7A", "#4B8BCC"),
    "Greyhound Grape":       two("#2B2080", "#8B5CF6"),
    "Mongrel Moss":          "#565656",
    "Otterhound Orange":     "#FE816D",
    "Pointer Purple":        "#5347A8",
    "Pyrenees Plum":         "#86233A",
    "Rasta":                 two("#336E6A", "#8D1D38"),
    "Basalt":                two("#040608", "#D6D9DC"),
    "Cotton Candy":          "#D30892",
    "Kermit":                "#418E83",
    "Onyx":                  "#141414",
    "Fire Brick":            two("#9E3530", "#93A7B8"),
    "Sea Glass":             "#2E9BB5",
    "Glacier":               two("#2F53B5", "#C9D6E2"),
    "Forest":                two("#1F4A4C", "#343A61"),
    "Granite":               two("#15171A", "#C2CACB"),
    "Nebula":                two("#372C73", "#C1D8E7"),
    "Sunburst":              two("#DE4A33", "#E2D97C"),
    /* Not in the PDP map yet; sampled from the product photo (neon yellow with navy fleck). */
    "High Visibility":       two("#D4EF2C", "#303244"),
    "Chili Pepper": "#A51F20", "Black": "#232323", "Blue": "#2F3F92",
    "Desert Sunset": "#E97A4D", "Northern Light": "#58D3B9", "Red": "#D44848",
    "Sprout": "#A5DC95", "Tan": "#D7CD8F", "Yellow": "#EEE84E"
  };

  /* ── CATALOGUE HELPERS ───────────────────────────────────────────────── */
  var CAT = D.catalog;
  function cat(h) { return CAT[h] || {}; }
  function money(cents) { return "$" + (cents / 100).toFixed(2); }

  function buildColors(handle, fallbackList) {
    var c = cat(handle);
    var names = (c.colors && c.colors.length) ? c.colors : fallbackList.map(function (x) { return x.name; });
    var fbImg = {};
    fallbackList.forEach(function (x) { fbImg[x.name] = x.img; });
    return names.map(function (n) {
      return {
        name:  n,
        hex:   HEX[n] || null,
        img:   (c.colorImages && c.colorImages[n]) || fbImg[n] || "",
        avail: c.colorAvail ? c.colorAvail[n] !== false : true
      };
    });
  }

  function buildLengths(handle, fallback) {
    var c = cat(handle);
    var list = (c.lengths && c.lengths.length) ? c.lengths : (fallback || []);
    // The 1 ft option on the Standard Clip is the Traffic Lead, which the results screen offers separately.
    return list.filter(function (l) { return !/traffic lead/i.test(l); });
  }

  function def(handle, fields, fallbackColors, fallbackLengths) {
    var c = cat(handle);
    var o = {
      handle:      handle,
      url:         BASE + handle,
      image:       c.image || "",
      price:       c.price || "",
      colorImages: c.colorImages || {},
      colors:      fallbackColors ? buildColors(handle, fallbackColors) : null,
      // Second colour option (the bundle's Traffic Lead); availability depends on the first pick, see pairAvail().
      colors2:     (fallbackColors && c.colors2 && c.colors2.length) ? c.colors2.map(function (n) {
                     var fb = fallbackColors.filter(function (x) { return x.name === n; })[0];
                     return { name: n, hex: HEX[n] || null, img: (fb && fb.img) || "" };
                   }) : null,
      pairs:       c.pairs || null,
      lengths:     fallbackLengths === null ? null : buildLengths(handle, fallbackLengths)
    };
    Object.keys(fields).forEach(function (k) { o[k] = fields[k]; });
    return o;
  }

  var STD = D.colors.std || [];
  var MINI = D.colors.mini || [];
  var ADJ = ["Adjustable"];

  /* ── PRODUCTS ────────────────────────────────────────────────────────── */
  var P = {
    BUNDLE: def("the-ultimate-bundle", {
      name:    "The Ultimate Leash Bundle",
      tagline: "Three leashes. Zero guessing. Every walk, every situation, covered.",
      body:    "One system that goes everywhere you do, from city sidewalks to backcountry trails. Includes the Hands-Free Clip leash, a 20' Long Line, and the Traffic Lead. This is the exact setup our founder uses every single day.",
      tags:    ["Complete System", "3 Leashes Included", "City + Trail + Everything", "Best Value"],
      picker1: "Hands-Free Clip color: ",
      picker2: "Traffic Lead color: ",
      note:    "The 20 ft long line ships in a surprise high-visibility color, hand-picked so it stays easy to spot on the trail.",
      // Bought separately: hands-free clip + 20 ft standard clip + traffic lead at full price.
      parts:   [["hands-free-standard-clip-leash"], ["standard-clip-leash", "20 ft"], ["traffic-lead", "compare"]]
    }, STD, null),
    FTS: def("the-trainers-full-system", {
      name:    "The Trainer's Full System",
      tagline: "The complete slip leash setup that professionals use, built for every distance, every dog, every day.",
      body:    "The 20-footer for recall work, open trails, and off-leash conditioning. The 6-footer for daily walks and training sessions. And the 1-foot traffic lead for the moments when you need your dog locked in close: parking lots, vet visits, loading into the car.",
      tags:    ["Complete Slip System", "3 Leads Included", "20 ft Recall Line", "Trainer's Choice"],
      picker1: "6 ft Slip color: ",
      picker2: "Traffic Lead color: ",
      note:    "The 20 ft slip leash ships in a hand-picked rare or high-visibility color.",
      parts:   [["standard-slip-leash", "6 ft"], ["standard-slip-leash", "20 ft"], ["traffic-lead", "compare"]]
    }, STD, null),
    HF_STD_CAR: def("hands-free-standard-carabiner-leash", {
      name:    "Hands-Free Carabiner Leash",
      tagline: "Maximum security meets total freedom, built for active owners with powerful dogs.",
      body:    "Our locking carabiner (rated to 5,000 lbs) means this leash will never accidentally pop open on a trail or a crowded street. Wear it crossbody or around your waist. Adjusts from 3'9\" to 7'.",
      tags:    ["Hands-Free", "Locking Carabiner", "Active Owners", "Strong & Reactive Dogs"]
    }, STD, ADJ),
    HF_STD_CLIP: def("hands-free-standard-clip-leash", {
      name:    "Hands-Free Clip Leash",
      tagline: "Your walk, your hands. The 4-in-1 leash for owners who do it all.",
      body:    "Clip it around your waist or wear it crossbody. Shorten it for sidewalks, extend it for the park, go fully hands-free for the trail, or loop it to walk two dogs at once. One leash, every situation.",
      tags:    ["Hands-Free", "4-in-1 Versatility", "Runs & Hikes", "Two-Dog Ready"]
    }, STD, ADJ),
    STD_CAR: def("standard-carabiner-leash", {
      name:    "Standard Carabiner Leash",
      tagline: "When you need a leash that will absolutely, never, under any circumstances, let go.",
      body:    "Built with the same locking carabiner hardware climbers trust. If your dog is a determined puller, a bolter, or unpredictable around other dogs, this is your leash.",
      tags:    ["Locking Carabiner", "5,000 lb Hold", "Reactive Dogs", "Escape-Proof Hardware"],
      dfltLen: "6 ft"
    }, STD, ["2 ft", "4 ft", "6 ft", "8 ft", "10 ft", "20 ft"]),
    STD_CLIP: def("standard-clip-leash", {
      name:    "Standard Clip Leash",
      tagline: "The everyday leash, done exactly right. Built to outlast your dog's puppy phase.",
      body:    "Upcycled climbing rope rated to 4,000+ lbs, hand-assembled in Phoenix, and backed by an unconditional lifetime guarantee. This is the workhorse leash that lives by your front door.",
      tags:    ["Classic Clip", "Multiple Lengths", "Everyday Walking", "Lifetime Guarantee"],
      dfltLen: "6 ft"
    }, STD, ["2 ft", "4 ft", "6 ft", "8 ft", "10 ft", "20 ft"]),
    SLIP_STD: def("standard-slip-leash", {
      name:    "Standard Slip Leash",
      tagline: "The trainer's choice: collar and leash in one, for those serious about connection.",
      body:    "Think of it like driving a stick shift: more effort to learn, infinitely more rewarding once you do. One fluid movement gives you complete, immediate control. Preferred by professional trainers worldwide. 10.5mm rope.",
      tags:    ["Trainer Preferred", "Collar + Leash in One", "10.5mm Rope", "Full Control"],
      dfltLen: "6 ft"
    }, STD, ["6 ft", "20 ft"]),
    SLIP_MINI: def("mini-slip-leash", {
      name:    "Mini Slip Leash",
      tagline: "All the control of a slip lead, in a lighter, sleeker 7mm build.",
      body:    "Same trainer-preferred slip mechanism as the Standard, just a lighter rope that's less bulky in hand and on your dog. Works beautifully for dogs of any size. A great choice if you prefer something more nimble.",
      tags:    ["Trainer Preferred", "7mm Rope", "Lighter Build", "Any Size Dog"],
      dfltLen: "6 ft"
    }, MINI, ["6 ft", "20 ft"]),
    HF_MINI: def("hands-free-mini-clip-leash", {
      name:    "Hands-Free Mini Clip Leash",
      tagline: "Lightweight hands-free freedom, perfectly scaled for small dogs and busy owners.",
      body:    "Our 7mm rope keeps things light and nimble, about 50% lighter than the standard. Wear it crossbody or around your waist. Perfect when you have a coffee in one hand, a stroller to push, or kids to chase.",
      tags:    ["Hands-Free", "Lightweight 7mm", "Small Dogs", "Crossbody or Waist"]
    }, MINI, ADJ),
    MINI_CLIP: def("mini-clip-leash", {
      name:    "Mini Clip Leash",
      tagline: "Big durability in a lightweight build, sized right for your small dog.",
      body:    "The same climbing rope quality and lifetime guarantee as our full-size leashes, scaled down with 7mm anchor cord and lighter hardware. Your small dog deserves a leash that takes their walks as seriously as you do.",
      tags:    ["Lightweight 7mm", "Small Dogs", "Multiple Lengths", "Lifetime Guarantee"],
      dfltLen: "6 ft"
    }, MINI, ["2 ft", "4 ft", "6 ft", "8 ft", "10 ft", "20 ft"])
  };
  Object.keys(P).forEach(function (k) { P[k].key = k; });

  var TRAFFIC = def("traffic-lead", { name: "Traffic Lead" }, null, null);
  var BACKUP_CLIP = def("backup-clip", {
    name: "Backup Clip",
    desc: "A slip lead works by tightening and releasing, which means there is no secondary attachment point if the loop needs to be repositioned or your dog backs out unexpectedly. The Backup Clip clips to your dog's collar and to the leash, giving you a fixed safety connection so you are never fully unclipped during the adjustment. Professionals use one every time."
  }, null, null);

  var MINI_KEYS = { MINI_CLIP: true, SLIP_MINI: true, HF_MINI: true };
  var SLIP_KEYS = { SLIP_STD: true, SLIP_MINI: true, FTS: true };

  /* ── QUESTIONS ───────────────────────────────────────────────────────── */
  var QS = [
    { id: "q1", q: "Are you a professional trainer or pack walker?", sub: "We serve dog owners and dog professionals alike. Let us know where you are starting from.",
      opts: [
        { ico: "🐶", lbl: "No, just a dog owner", desc: "My dog is my companion, not a client", sc: { STD_CLIP: 1 } },
        { ico: "🎓", lbl: "Yes, I am a professional trainer", desc: "I train dogs for a living", sc: { SLIP_STD: 5, SLIP_MINI: 2, STD_CAR: 1 } },
        { ico: "🐕‍🦺", lbl: "Yes, I do pack walks", desc: "I walk groups of dogs regularly", sc: { HF_STD_CLIP: 4, BUNDLE: 1, STD_CAR: 1 } }
      ] },
    { id: "q2", q: "How big is your dog?", sub: "This helps us match the right rope weight and hardware.",
      opts: [
        { ico: "🐾", lbl: "Small (under 25 lbs)", desc: "Little legs, massive personality", sc: { MINI_CLIP: 3, HF_MINI: 3, SLIP_MINI: 2 } },
        { ico: "🐕", lbl: "Medium (25-60 lbs)", desc: "Balanced and manageable", sc: { STD_CLIP: 2, HF_STD_CLIP: 1, SLIP_STD: 1, STD_CAR: 1 } },
        { ico: "🦮", lbl: "Large (60+ lbs)", desc: "Built for adventure and doesn't let you forget it", sc: { STD_CAR: 2, STD_CLIP: 1, HF_STD_CLIP: 1, SLIP_STD: 2, HF_STD_CAR: 1 } },
        { ico: "🐕‍🦺", lbl: "I have more than one dog", desc: "Multiple dogs often means different sizes, needs, and walks", sc: { HF_STD_CLIP: 3, BUNDLE: 1, STD_CLIP: 1 } }
      ] },
    { id: "q3", q: "How does your dog behave on a leash?", sub: "Honest answer, we have heard it all.",
      opts: [
        { ico: "😇", lbl: "A total angel", desc: "Heels beautifully, zero pulling, zero drama", sc: { STD_CLIP: 2, MINI_CLIP: 1, SLIP_STD: 1, SLIP_MINI: 1 } },
        { ico: "😅", lbl: "Gets excited but I can handle it", desc: "Pulls sometimes, manageable with a firm hand", sc: { STD_CLIP: 1, MINI_CLIP: 1, STD_CAR: 1, HF_STD_CLIP: 1 } },
        { ico: "💪", lbl: "Strong, determined puller", desc: "Built like a truck and walks like one too", sc: { STD_CAR: 4, HF_STD_CAR: 2, SLIP_STD: 1 } },
        { ico: "⚡", lbl: "Reactive or unpredictable", desc: "Can lunge, bolt, or react unexpectedly. Safety is non-negotiable.", sc: { STD_CAR: 5, HF_STD_CAR: 3 } }
      ] },
    { id: "q4", q: "What does a typical outing look like?", sub: "Pick the one that fits your life most of the time.",
      opts: [
        { ico: "🏘️", lbl: "Neighborhood walks and daily errands", desc: "Morning loops, coffee runs, the usual routine", sc: { STD_CLIP: 3, MINI_CLIP: 1 } },
        { ico: "🏔️", lbl: "Trail runs, hikes, and outdoor adventures", desc: "We live for wide-open spaces and fresh air", sc: { HF_STD_CLIP: 3, HF_STD_CAR: 2, HF_MINI: 1 } },
        { ico: "👶", lbl: "Always juggling - kids, a stroller, or both hands full", desc: "Walking the dog is never the only thing on my plate", sc: { HF_STD_CLIP: 3, HF_MINI: 2 } },
        { ico: "🗺️", lbl: "A bit of everything - city, trails, errands", desc: "We go wherever life takes us and need to be ready", sc: { BUNDLE: 5, HF_STD_CLIP: 1 } }
      ] },
    { id: "q5", q: "Are you actively training your dog?", sub: "Not just sit-stay, but working on real obedience and connection.",
      opts: [
        { ico: "🌀", lbl: "Not really, we just enjoy our walks", desc: "Training is not a current priority", sc: { STD_CLIP: 2, HF_STD_CLIP: 1 } },
        { ico: "📚", lbl: "Working on basic manners and obedience", desc: "Sit, stay, loose-leash walking - the essentials", sc: { SLIP_STD: 2, SLIP_MINI: 1, STD_CAR: 1 } },
        { ico: "🏆", lbl: "Yes, training is serious - I want full control and connection", desc: "We put in the work and the leash matters", sc: { SLIP_STD: 4, SLIP_MINI: 2 } }
      ] },
    { id: "q6", q: "What matters more when it comes to feel?", sub: "Neither is wrong. It is all about what works for you.",
      opts: [
        { ico: "💪", lbl: "Thick and substantial in my hand", desc: "10.5mm rope - heavier feel, more grip and presence", sc: { STD_CLIP: 2, STD_CAR: 1, SLIP_STD: 2, HF_STD_CLIP: 1, HF_STD_CAR: 1, BUNDLE: 1 } },
        { ico: "🪶", lbl: "Light, slim, and easy to store", desc: "7mm rope - fits in a small bag, lighter on the dog too", sc: { MINI_CLIP: 2, SLIP_MINI: 2, HF_MINI: 2 } }
      ] }
  ];

  /* ── STATE ───────────────────────────────────────────────────────────── */
  var S = freshState();
  function freshState() {
    return { step: 0, ans: { q1: null, q2: null, q3: null, q4: null, q5: null, q6: null }, fname: "", result: null, selColor: null, selColor2: null, selLen: null, opener: null, scrollY: 0 };
  }
  function isSize(word) { return !!(S.ans.q2 && S.ans.q2.lbl.indexOf(word) !== -1); }

  /* ── TRACKING ────────────────────────────────────────────────────────── */
  function track(ev, params) {
    params = params || {};
    try {
      if (TRACKING.meta && typeof fbq  !== "undefined") fbq("trackCustom", ev, params);
      if (TRACKING.ga4  && typeof gtag !== "undefined") gtag("event", ev, params);
    } catch (e) {}
  }

  /* ── SCORING ─────────────────────────────────────────────────────────── */
  function compute() {
    var sc = { BUNDLE: 0, FTS: 0, HF_STD_CAR: 0, HF_STD_CLIP: 0, STD_CAR: 0, STD_CLIP: 0, SLIP_STD: 0, SLIP_MINI: 0, HF_MINI: 0, MINI_CLIP: 0 };
    ["q1", "q2", "q3", "q4", "q5", "q6"].forEach(function (k) {
      var a = S.ans[k];
      if (!a) return;
      Object.keys(a.sc).forEach(function (pk) { if (sc[pk] !== undefined) sc[pk] += a.sc[pk]; });
    });
    var ranked = Object.keys(sc).sort(function (a, b) { var d = sc[b] - sc[a]; return d !== 0 ? d : (a < b ? -1 : 1); });
    return { key: ranked[0], ranked: ranked, scores: sc };
  }

  // Dogs under 25 lbs always get a mini; dogs 60+ lbs never do.
  var MINI_MAP  = { STD_CLIP: "MINI_CLIP", SLIP_STD: "SLIP_MINI", HF_STD_CLIP: "HF_MINI", STD_CAR: "MINI_CLIP", HF_STD_CAR: "HF_MINI", BUNDLE: "HF_MINI", FTS: "SLIP_MINI" };
  var LARGE_MAP = { MINI_CLIP: "STD_CLIP", SLIP_MINI: "SLIP_STD", HF_MINI: "HF_STD_CLIP" };

  // The Trainer's Full System is the Standard Slip plus a 20 ft slip and a traffic lead.
  // It replaces a Standard Slip result when the answers call for distance work or varied
  // situations: professional trainers, pack walkers, trail / hike days, and "a bit of everything".
  function wantsFullSystem() {
    var q1 = S.ans.q1 ? S.ans.q1.lbl : "", q4 = S.ans.q4 ? S.ans.q4.lbl : "";
    return q1.indexOf("professional trainer") !== -1 || q1.indexOf("pack walks") !== -1 ||
           /trail/i.test(q4) || q4.indexOf("everything") !== -1;
  }

  function applyOverrides(r) {
    // Serious training → slip lead
    if (S.ans.q5 && S.ans.q5.lbl.indexOf("serious") !== -1 && !SLIP_KEYS[r.key]) {
      r.key = isSize("Small") ? "SLIP_MINI" : "SLIP_STD";
    }
    if (isSize("Small") && MINI_MAP[r.key])  r.key = MINI_MAP[r.key];
    if (isSize("Large") && LARGE_MAP[r.key]) r.key = LARGE_MAP[r.key];
    if (r.key === "SLIP_STD" && wantsFullSystem()) {
      r.key = "FTS";
      r.ranked = ["SLIP_STD"].concat(r.ranked.filter(function (k) { return k !== "SLIP_STD"; }));
    }
    r.primary   = P[r.key];
    r.secondary = pickSecondary(r.key, r.ranked);
    return r;
  }

  // The alternative must differ from the pick and respect the same size rules.
  function pickSecondary(primaryKey, ranked) {
    var small = isSize("Small"), large = isSize("Large");
    for (var i = 0; i < ranked.length; i++) {
      var k = ranked[i];
      if (k === primaryKey) continue;
      if (small && !MINI_KEYS[k]) continue;
      if (large && MINI_KEYS[k]) continue;
      return P[k];
    }
    return null;
  }

  // Q6 (rope feel) only applies to medium / multi-dog owners.
  function shouldSkipQ6() { return isSize("Small") || isSize("Large"); }
  function totalQs() { return shouldSkipQ6() ? 5 : 6; }

  /* ── PROGRESS ────────────────────────────────────────────────────────── */
  function setProgress(s) {
    var t = totalQs();
    var pct = 0, lbl = "";
    if (s >= 1 && s <= 6) { pct = Math.round(s / (t + 2) * 100); lbl = "Step " + s + " of " + t; }
    else if (s === 7)     { pct = Math.round((t + 1) / (t + 2) * 100); lbl = "Almost there..."; }
    else if (s === 8)     { pct = 100; lbl = "Your results"; }
    var pEl = document.getElementById("mdpProg");
    var lEl = document.getElementById("mdpStepLbl");
    if (pEl) pEl.style.width = pct + "%";
    if (lEl) lEl.textContent = lbl;
  }

  /* ── NAVIGATION ──────────────────────────────────────────────────────── */
  function goTo(step) {
    S.step = step;
    setProgress(step);
    var el = document.getElementById("mdpBody");
    if (!el) return;
    el.innerHTML = "";
    if      (step <= 6)  renderQ(el, step);
    else if (step === 7) renderEmail(el);
    else                 renderResults(el);
    el.classList.remove("mdp-fade");
    void el.offsetWidth;
    el.classList.add("mdp-fade");
    var wrap = document.querySelector("#mdpModalOverlay .mdp-wrap");
    if (wrap) wrap.scrollTop = 0;
  }

  /* ── HELPERS ─────────────────────────────────────────────────────────── */
  function esc(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function cdnResize(url, w) {
    if (!url || url.indexOf("cdn.shopify.com") === -1) return url;
    return url + (url.indexOf("?") !== -1 ? "&" : "?") + "width=" + (w || 400);
  }
  function hasLengthPicker(prod) { return !!(prod.lengths && prod.lengths.length && !/^Adjustable/.test(prod.lengths[0])); }

  function priceCentsFor(prod) {
    var c = cat(prod.handle);
    if (hasLengthPicker(prod) && S.selLen && c.lenPrices && c.lenPrices[S.selLen] != null) return c.lenPrices[S.selLen];
    if (S.selColor && c.colorPrices && c.colorPrices[S.selColor.name] != null) return c.colorPrices[S.selColor.name];
    return c.priceCents || 0;
  }
  function priceLabel(prod) {
    var cents = priceCentsFor(prod);
    return cents ? money(cents) : (prod.price || "");
  }

  // Bundle saving vs buying its pieces separately, from live prices. 0 when unknown.
  function bundleSaveCents(prod) {
    if (!prod || !prod.parts) return 0;
    var total = 0;
    for (var i = 0; i < prod.parts.length; i++) {
      var c = cat(prod.parts[i][0]), sel = prod.parts[i][1], cents = 0;
      if (sel === "compare") cents = c.compareAtCents || c.priceCents;
      else if (sel) cents = c.lenPrices && c.lenPrices[sel];
      else cents = c.priceCents;
      if (!cents) return 0;
      total += cents;
    }
    return total - priceCentsFor(prod);
  }

  /*
   * Resolve the Shopify variant for the shopper's colour and length from /products/<handle>.js.
   * Every option whose name contains "Color" must equal the chosen colour (the bundle has two),
   * and the "Length" option must equal the chosen length. Never substitutes a different variant.
   * callback(variantId | null, reason: null | "oos" | "nomatch" | "error")
   */
  function fetchVariantId(prod, callback) {
    fetch("/products/" + prod.handle + ".js")
      .then(function (res) { if (!res.ok) throw new Error("not found"); return res.json(); })
      .then(function (data) {
        var variants = data.variants || [];
        var opts = data.options || [];
        var colorIdx = [], lenIdx = -1;
        opts.forEach(function (o, i) {
          var n = String(o && o.name != null ? o.name : o).toLowerCase();
          if (n.indexOf("color") !== -1 || n.indexOf("colour") !== -1) colorIdx.push(i);
          else if (n.indexOf("length") !== -1) lenIdx = i;
        });
        var colorName  = (prod.colors && S.selColor) ? S.selColor.name.toLowerCase() : "";
        var colorName2 = (prod.colors2 && S.selColor2) ? S.selColor2.name.toLowerCase() : colorName;
        var lenName    = (hasLengthPicker(prod) && S.selLen) ? S.selLen.toLowerCase() : "";
        var matches = variants.filter(function (v) {
          var o = [v.option1, v.option2, v.option3];
          for (var k = 0; k < colorIdx.length; k++) {
            var want = k === 0 ? colorName : colorName2;
            if (want && String(o[colorIdx[k]] || "").toLowerCase() !== want) return false;
          }
          if (lenIdx >= 0 && lenName && String(o[lenIdx] || "").toLowerCase() !== lenName) return false;
          return true;
        });
        if (!matches.length) { callback(null, "nomatch"); return; }
        var avail = matches.filter(function (v) { return v.available; });
        if (!avail.length) { callback(null, "oos"); return; }
        callback(String(avail[0].id), null);
      })
      .catch(function () { callback(null, "error"); });
  }

  function msgFor(btn) {
    var m = btn.nextElementSibling;
    if (!(m && m.classList && m.classList.contains("mdp-cta-msg"))) {
      m = document.createElement("div");
      m.className = "mdp-cta-msg";
      btn.insertAdjacentElement("afterend", m);
    }
    return m;
  }
  function setMsg(btn, html, isErr) {
    var m = msgFor(btn);
    m.innerHTML = html || "";
    m.classList.toggle("err", !!isErr);
  }
  function pdpLink(prod, text) {
    return '<a href="' + esc(prod.url) + '" target="_blank" rel="noopener">' + esc(text) + '</a>';
  }

  function explainFailure(btn, prod, reason, idleLabel) {
    btn.disabled = false;
    btn.textContent = idleLabel;
    var combo = [];
    if (prod.colors && S.selColor) combo.push(S.selColor.name);
    if (prod.colors2 && S.selColor2) combo.push(S.selColor2.name);
    if (hasLengthPicker(prod) && S.selLen) combo.push(S.selLen);
    var what = combo.length ? combo.join(" / ") : "That option";
    if (reason === "oos") {
      setMsg(btn, esc(what) + " is sold out right now. Try another colour or length, or " + pdpLink(prod, "see the product page") + ".", true);
    } else {
      setMsg(btn, "We couldn't add that combination. " + pdpLink(prod, "See all options on the product page →"), true);
    }
  }

  function refreshCartBadge() {
    return fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      try {
        document.dispatchEvent(new CustomEvent("cart:update", {
          bubbles: true,
          detail: { resource: cart, sourceId: "mdp-quiz", data: { itemCount: cart.item_count, source: "mdp-quiz" } }
        }));
      } catch (e) {}
      return cart;
    }).catch(function () {});
  }

  function doCartAdd(btn, variantId, prod, idleLabel) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (res) {
      if (!res.ok) throw new Error("cart error");
      btn.disabled = false;
      btn.classList.add("added");
      btn.textContent = "✓ Added · View cart →";
      btn.onclick = function () { viewCart(); };
      setMsg(btn, "", false);
      track("AddToCart", { content_name: prod.name, content_ids: [variantId], content_type: "product", source: "MDP Leash Finder" });
      refreshCartBadge();
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = idleLabel;
      setMsg(btn, "Couldn't add to cart. " + pdpLink(prod, "Open the product page →"), true);
    });
  }

  // Close the quiz, then open whatever cart the theme is running (UpCart when present).
  function viewCart() {
    close();
    setTimeout(function () {
      if (typeof window.upcartOpenCart === "function") { window.upcartOpenCart(); return; }
      var d = document.querySelector("cart-drawer-component");
      if (d && typeof d.open === "function") { d.open(); return; }
      window.location.href = "/cart";
    }, 60);
  }

  /* ── QUESTION SCREENS ────────────────────────────────────────────────── */
  function renderQ(el, step) {
    var q = QS[step - 1];
    var ans = S.ans[q.id];
    var cards = q.opts.map(function (opt, i) {
      var sel = ans && ans === opt;
      return [
        '<button type="button" class="mdp-card' + (sel ? " mdp-sel" : "") + '" aria-pressed="' + (sel ? "true" : "false") + '" onclick="MDP.pick(' + step + ',' + i + ')">',
          '<span class="mdp-card-ico" aria-hidden="true">' + opt.ico + '</span>',
          '<span class="mdp-card-txt">',
            '<span class="mdp-card-lbl">' + esc(opt.lbl) + '</span>',
            '<span class="mdp-card-desc">' + esc(opt.desc) + '</span>',
          '</span>',
          '<span class="mdp-card-chk" aria-hidden="true">' + (sel ? "✓" : "") + '</span>',
        '</button>'
      ].join("");
    }).join("");
    var hasAns = !!ans;
    el.innerHTML = [
      '<h2 class="mdp-q-head" id="mdpDialogTitle">' + esc(q.q) + '</h2>',
      '<div class="mdp-q-sub">' + esc(q.sub) + '</div>',
      '<div class="mdp-opts">' + cards + '</div>',
      '<div class="mdp-nav">',
        step > 1 ? '<button type="button" class="mdp-btn-back" onclick="MDP.back()">← Back</button>' : '<div></div>',
        '<button type="button" class="mdp-btn-next' + (hasAns ? " on" : "") + '" id="mdpNext" onclick="MDP.next()">' + (step < 6 ? "Continue →" : "See My Results →") + '</button>',
      '</div>'
    ].join("");
  }

  /* ── EMAIL GATE ──────────────────────────────────────────────────────── */
  function renderEmail(el) {
    el.innerHTML = [
      '<div class="mdp-email-eye">One Last Step</div>',
      '<h2 class="mdp-q-head" id="mdpDialogTitle">Your perfect leash is ready.</h2>',
      '<div class="mdp-q-sub" style="margin-bottom:24px;">Enter your details to see your personalized recommendation, plus a first-purchase discount just for you.</div>',
      '<label class="mdp-lbl" for="mdpFname">First Name</label>',
      '<input class="mdp-inp" type="text" id="mdpFname" placeholder="Your first name" autocomplete="given-name">',
      '<label class="mdp-lbl" for="mdpEmail">Email Address</label>',
      '<input class="mdp-inp" type="email" id="mdpEmail" placeholder="your@email.com" autocomplete="email" inputmode="email">',
      '<div class="mdp-err" id="mdpErr" aria-live="polite"></div>',
      '<button type="button" class="mdp-btn-sub" id="mdpSubBtn" onclick="MDP.submitEmail()">See My Recommendation →</button>',
      '<div class="mdp-privacy">🔒 No spam, ever. Unsubscribe anytime.</div>',
      '<div class="mdp-nav" style="margin-top:20px;">',
        '<button type="button" class="mdp-btn-back" onclick="MDP.back()">← Back</button>',
        '<div></div>',
      '</div>'
    ].join("");
    var fn = document.getElementById("mdpFname");
    if (fn) fn.focus();
    ["mdpFname", "mdpEmail"].forEach(function (id) {
      var i = document.getElementById(id);
      if (i) i.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); submitEmail(); } });
    });
  }

  /* ── RECOMMENDATION REASON ──────────────────────────────────────────── */
  function getRecommendationReason(key, ans) {
    var lines = [];
    var q1 = ans.q1 ? ans.q1.lbl : "", q2 = ans.q2 ? ans.q2.lbl : "", q3 = ans.q3 ? ans.q3.lbl : "", q4 = ans.q4 ? ans.q4.lbl : "", q5 = ans.q5 ? ans.q5.lbl : "";
    var isSlip = !!SLIP_KEYS[key];
    var isCar = (key === "STD_CAR" || key === "HF_STD_CAR");
    var isHF = (key === "HF_STD_CLIP" || key === "HF_STD_CAR" || key === "HF_MINI");
    var isMini = !!MINI_KEYS[key];
    var isBundle = (key === "BUNDLE");

    if (key === "FTS") {
      lines.push("The Full System gives you the 20 ft line for recall and distance work, the 6 ft slip for daily walks and training, and the traffic lead for close control.");
    }
    if (q1.indexOf("professional trainer") !== -1) {
      lines.push(isSlip
        ? "Professional trainers rely on slip leads for the instant, clear communication they give between handler and dog."
        : "Even experienced trainers reach for different tools depending on the situation. This pick fits what you described.");
    } else if (q1.indexOf("pack walks") !== -1) {
      lines.push("Pack walkers need a system that handles multiple dogs efficiently without losing control or versatility.");
    }
    if (q3.indexOf("Reactive") !== -1) {
      lines.push(isCar
        ? "With a reactive dog, the locking carabiner is non-negotiable. A standard clip can pop open under sudden force."
        : "With a reactive dog, keeping walks controlled and predictable matters. This leash gives you the handling to do exactly that.");
    } else if (q3.indexOf("puller") !== -1) {
      lines.push(isCar
        ? "A determined puller needs hardware rated for real force. The locking carabiner will not accidentally open under load."
        : "Built for real-world pulling, not just light resistance. This leash handles it without wearing out your hands.");
    }
    if (q5.indexOf("serious") !== -1) {
      if (isSlip) lines.push("Serious training calls for a slip lead: collar and leash in one, giving you immediate pressure-and-release feedback and total control over your dog.");
      else if (isHF) lines.push("Serious training works best when you have total freedom of movement. Going hands-free keeps you focused on your dog, not managing gear.");
      else if (isMini) lines.push("The 7mm build is lighter and less intrusive, ideal when you need your dog to stay focused on you, not a heavy leash.");
    } else if (q5.indexOf("basic") !== -1 && isSlip) {
      lines.push("Working on obedience? A slip lead reinforces your cues with clearer communication than a standard clip.");
    }
    if (/trail/i.test(q4)) {
      if (isHF) lines.push("For trail runs and hikes, going hands-free keeps you balanced and frees your hands when you need them.");
    } else if (q4.indexOf("juggling") !== -1) {
      if (isHF) lines.push("When your hands are constantly full, a hands-free leash removes one more thing to manage on every walk.");
    } else if (q4.indexOf("everything") !== -1 && isBundle) {
      lines.push("You go everywhere and need to be ready for anything. The Bundle gives you the right leash for every situation without compromise.");
    }
    if (lines.length === 0) {
      if (isMini) lines.push("The lighter 7mm rope is the right call here: less bulk on a smaller dog, easier in hand, same climbing-grade durability.");
      else if (q2.indexOf("more than one") !== -1) lines.push("With multiple dogs in the mix, versatility matters. This leash handles the everyday reliably across different sizes and personalities.");
      else if (isBundle) lines.push("Three leashes, zero gaps. The Bundle covers every scenario you described without having to think about which leash to grab.");
      else lines.push("This recommendation is based on your dog's profile and your walking style. Built for exactly what your days look like.");
    }
    return lines.slice(0, 2).join(" ");
  }

  /* ── RESULTS SCREEN ──────────────────────────────────────────────────── */
  function firstAvailableColor(prod) {
    if (!prod.colors || !prod.colors.length) return null;
    for (var i = 0; i < prod.colors.length; i++) if (prod.colors[i].avail) return prod.colors[i];
    return prod.colors[0];
  }

  function swatchStyle(c) {
    if (c.hex) return "background:" + c.hex + ";";
    if (c.img) return "background-image:url(" + c.img + ");";
    return "background:#CCCCCC;";
  }

  // Second colour option: a pair is orderable only if that exact variant exists and is in stock.
  function pairAvail(prod, name2) {
    if (!prod.pairs || !S.selColor) return true;
    return prod.pairs[S.selColor.name + "|" + name2] === true;
  }
  function defaultColor2(prod) {
    if (!prod.colors2) return null;
    var same = prod.colors2.filter(function (c) { return S.selColor && c.name === S.selColor.name && pairAvail(prod, c.name); })[0];
    if (same) return same;
    return prod.colors2.filter(function (c) { return pairAvail(prod, c.name); })[0] || null;
  }
  function swatchBtn(c, isOn, avail, handler) {
    return '<button type="button" class="mdp-sw' + (isOn ? " on" : "") + (avail ? "" : " oos") + '" style="' + swatchStyle(c) + '"' +
           ' aria-label="' + esc(c.name + (avail ? "" : " (sold out)")) + '" aria-pressed="' + (isOn ? "true" : "false") + '" title="' + esc(c.name + (avail ? "" : " (sold out)")) + '"' +
           (avail ? ' onclick="' + handler + '"' : ' disabled') + '></button>';
  }
  function color2RowHtml(prod) {
    if (!prod.colors2) return "";
    return prod.colors2.map(function (c, i) {
      return swatchBtn(c, S.selColor2 && S.selColor2.name === c.name, pairAvail(prod, c.name), "MDP.pickColor2(" + i + ")");
    }).join("");
  }

  function renderResults(el) {
    var r = S.result, prod = r.primary, sec = r.secondary;
    S.selColor = firstAvailableColor(prod);
    S.selColor2 = defaultColor2(prod);
    S.selLen = null;
    if (hasLengthPicker(prod)) {
      S.selLen = (prod.dfltLen && prod.lengths.indexOf(prod.dfltLen) !== -1) ? prod.dfltLen : prod.lengths[0];
    }
    track("QuizResultViewed", { recommended_product: prod.name, quiz_name: "MDP Leash Finder" });

    var imgSrc = (S.selColor && prod.colorImages[S.selColor.name]) || prod.image || PH_IMG;
    var imgHtml = '<img id="mdpProdImg" class="mdp-prod-img" src="' + esc(cdnResize(imgSrc, 800)) + '" alt="' + esc(prod.name) + '" />';
    var tagsHtml = prod.tags.map(function (t) { return '<span class="mdp-tag">' + esc(t) + '</span>'; }).join("");
    var whyHtml = '<div class="mdp-why"><div class="mdp-why-lbl">Why This Is Your Match</div><div class="mdp-why-txt">' + esc(getRecommendationReason(r.key, S.ans)) + '</div></div>';

    var colorHtml = "";
    if (prod.colors && prod.colors.length) {
      var swHtml = prod.colors.map(function (c, i) {
        return swatchBtn(c, S.selColor && S.selColor.name === c.name, c.avail, "MDP.pickColor(" + i + ")");
      }).join("");
      var lbl1 = (prod.colors2 && prod.picker1) ? prod.picker1 : "Choose your color: ";
      colorHtml = [
        '<div class="mdp-pick-sec">',
          '<div class="mdp-pick-lbl">' + esc(lbl1) + '<span class="mdp-pick-val" id="mdpColorName">' + (S.selColor ? esc(S.selColor.name) : "") + '</span></div>',
          '<div class="mdp-swatches" role="group" aria-label="' + esc(lbl1.replace(/:\s*$/, "")) + '">' + swHtml + '</div>',
        '</div>',
        prod.colors2 ? [
          '<div class="mdp-pick-sec">',
            '<div class="mdp-pick-lbl">' + esc(prod.picker2 || "Second color: ") + '<span class="mdp-pick-val" id="mdpColorName2">' + (S.selColor2 ? esc(S.selColor2.name) : "") + '</span></div>',
            '<div class="mdp-swatches" id="mdpSwatches2" role="group" aria-label="' + esc((prod.picker2 || "Second color").replace(/:\s*$/, "")) + '">' + color2RowHtml(prod) + '</div>',
            prod.note ? '<div class="mdp-pick-note">' + esc(prod.note) + '</div>' : "",
          '</div>'
        ].join("") : "",
      ].join("");
    }

    var lenHtml = "";
    if (hasLengthPicker(prod)) {
      var lenBtns = prod.lengths.map(function (l) {
        return '<button type="button" class="mdp-len-btn' + (S.selLen === l ? " on" : "") + '" aria-pressed="' + (S.selLen === l ? "true" : "false") + '" onclick="MDP.pickLen(this)" data-len="' + esc(l) + '">' + esc(l) + '</button>';
      }).join("");
      lenHtml = '<div class="mdp-pick-sec"><div class="mdp-pick-lbl">Choose your length:</div><div class="mdp-lens" role="group" aria-label="Length">' + lenBtns + '</div></div>';
    }

    var priceHtml = '<div class="mdp-price-row"><span class="mdp-price" id="mdpPrice">' + esc(priceLabel(prod)) + '</span><span class="mdp-price-note" id="mdpPriceNote">' + esc(priceNote(prod)) + '</span></div>';
    var ctaHtml = '<button type="button" class="mdp-cta" onclick="MDP.addToCart(this)">Add to Cart →</button><div class="mdp-cta-msg"></div>';

    var saveHtml = "";
    if (prod.parts) {
      var save = bundleSaveCents(prod);
      saveHtml = '<div class="mdp-mystery-badge" id="mdpSave" style="margin-bottom:16px;' + (save > 0 ? "" : "display:none;") + '">🏷️ Save ' + money(Math.max(save, 0)) + ' vs. buying separately</div>';
    }

    var discHtml = [
      '<div class="mdp-disc"><div class="mdp-disc-ico">🎁</div><div>',
        '<div class="mdp-disc-lbl">First-Time Customer Offer</div>',
        '<div class="mdp-disc-code">WELCOME10</div>',
        '<div class="mdp-disc-note">10% off your first order, enter at checkout</div>',
      '</div></div>'
    ].join("");
    var shipHtml = '<div class="mdp-ship"><span class="mdp-ship-ico">🚚</span><div class="mdp-ship-txt"><strong>Free shipping on orders over $150.</strong> Add the Traffic Lead and you might be closer than you think.</div></div>';

    /* Traffic Lead upsell: price and compare-at from the catalogue */
    var tl = cat("traffic-lead");
    var tlPct = (tl.compareAtCents && tl.priceCents && tl.compareAtCents > tl.priceCents) ? Math.round((1 - tl.priceCents / tl.compareAtCents) * 100) : 0;
    var upsellHtml = [
      '<div class="mdp-upsell">',
        '<div class="mdp-upsell-eye">Recommended Add-On</div>',
        '<div class="mdp-upsell-row">',
          '<img class="mdp-upsell-img" src="' + esc(cdnResize(TRAFFIC.image || PH_IMG, 144)) + '" alt="Traffic Lead" />',
          '<div class="mdp-upsell-copy">',
            '<div class="mdp-upsell-title">Traffic Lead</div>',
            '<div class="mdp-upsell-desc">Short-range control for the moments that matter.' + (tlPct > 0 ? " Take " + tlPct + "% off, and" : "") + ' we’ll send a surprise color your way.</div>',
            '<div class="mdp-upsell-pricing">',
              (tlPct > 0 ? '<span class="mdp-upsell-orig">' + esc(money(tl.compareAtCents)) + '</span>' : ""),
              '<span class="mdp-upsell-sale">' + esc(tl.priceCents ? money(tl.priceCents) : TRAFFIC.price) + '</span>',
              (tlPct > 0 ? '<span class="mdp-upsell-save-badge">' + tlPct + '% off</span>' : ""),
            '</div>',
          '</div>',
        '</div>',
        '<button type="button" class="mdp-upsell-cta" onclick="MDP.addToCart(this, true)">Add Traffic Lead to My Order →</button>',
      '</div>'
    ].join("");

    /* Backup Clip upsell, slip leads only */
    var backupHtml = "";
    if (SLIP_KEYS[r.key]) {
      backupHtml = [
        '<div class="mdp-upsell">',
          '<div class="mdp-upsell-eye">Recommended Add-On</div>',
          '<div class="mdp-upsell-row">',
            '<img class="mdp-upsell-img" src="' + esc(cdnResize(BACKUP_CLIP.image || PH_IMG, 144)) + '" alt="Backup Clip" />',
            '<div class="mdp-upsell-copy">',
              '<div class="mdp-upsell-title">Backup Clip</div>',
              '<div class="mdp-upsell-desc">' + esc(BACKUP_CLIP.desc) + '</div>',
              BACKUP_CLIP.price ? '<div class="mdp-upsell-pricing"><span class="mdp-upsell-sale">' + esc(BACKUP_CLIP.price) + '</span></div>' : "",
            '</div>',
          '</div>',
          '<button type="button" class="mdp-upsell-cta" onclick="MDP.addBackupClip(this)">Add Backup Clip to My Order →</button>',
        '</div>'
      ].join("");
    }

    var secHtml = "";
    if (sec) {
      secHtml = [
        '<div class="mdp-also-wrap"><div class="mdp-also-lbl">You Might Also Love</div>',
          '<a class="mdp-also-card" href="' + esc(sec.url) + '" target="_blank" rel="noopener">',
            '<img class="mdp-also-img" src="' + esc(cdnResize(sec.image || PH_IMG, 120)) + '" alt="' + esc(sec.name) + '" />',
            '<div class="mdp-also-body"><div class="mdp-also-name">' + esc(sec.name) + '</div><div class="mdp-also-tag">' + esc(sec.tagline) + '</div><div class="mdp-also-price">' + esc(sec.price) + '</div></div>',
            '<div class="mdp-also-arr" aria-hidden="true">→</div>',
          '</a>',
        '</div>'
      ].join("");
    }

    el.innerHTML = [
      imgHtml,
      '<div class="mdp-res-eye">Your Recommendation</div>',
      '<h2 class="mdp-res-name" id="mdpDialogTitle">' + esc(prod.name) + '</h2>',
      '<div class="mdp-res-tag">' + esc(prod.tagline) + '</div>',
      saveHtml,
      '<div class="mdp-tags">' + tagsHtml + '</div>',
      whyHtml, colorHtml, lenHtml, priceHtml, ctaHtml,
      upsellHtml, backupHtml, secHtml, discHtml, shipHtml,
      '<div class="mdp-restart">',
        '<button type="button" class="mdp-restart-btn" onclick="MDP.restart()">Start over</button>',
        '<button type="button" class="mdp-view-cart" onclick="MDP.openCart(event)">View Cart →</button>',
      '</div>'
    ].join("");
  }

  function priceNote(prod) {
    var parts = [];
    if (hasLengthPicker(prod) && S.selLen) parts.push(S.selLen);
    if (prod.colors && S.selColor) parts.push(S.selColor.name);
    if (prod.colors2 && S.selColor2) parts.push(S.selColor2.name + " traffic lead");
    return parts.join(" · ");
  }
  function refreshPrice() {
    var prod = S.result && S.result.primary;
    if (!prod) return;
    var p = document.getElementById("mdpPrice"), n = document.getElementById("mdpPriceNote");
    if (p) p.textContent = priceLabel(prod);
    if (n) n.textContent = priceNote(prod);
    var s = document.getElementById("mdpSave");
    if (s && prod.parts) {
      var save = bundleSaveCents(prod);
      s.style.display = save > 0 ? "" : "none";
      s.textContent = "🏷️ Save " + money(Math.max(save, 0)) + " vs. buying separately";
    }
    // Any earlier "added" state no longer describes the current selection.
    var cta = document.querySelector(".mdp-cta.added");
    if (cta) { cta.classList.remove("added"); cta.textContent = "Add to Cart →"; cta.onclick = function () { MDP.addToCart(cta); }; setMsg(cta, "", false); }
  }

  /* ── EMAIL SUBMISSION ────────────────────────────────────────────────── */
  function submitEmail() {
    var fname = ((document.getElementById("mdpFname") || {}).value || "").trim();
    var email = ((document.getElementById("mdpEmail") || {}).value || "").trim();
    var errEl = document.getElementById("mdpErr");
    var btn = document.getElementById("mdpSubBtn");
    if (btn && btn.disabled) return;
    if (!fname) { if (errEl) errEl.textContent = "Please enter your first name."; return; }
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { if (errEl) errEl.textContent = "Please enter a valid email address."; return; }
    if (errEl) errEl.textContent = "";
    if (btn) { btn.disabled = true; btn.textContent = "Finding your match..."; }

    S.fname = fname;
    S.result = applyOverrides(compute());
    track("QuizEmailSubmitted", { quiz_name: "MDP Leash Finder" });

    fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + KV_KEY, {
      method: "POST",
      headers: { "Content-Type": "application/json", "revision": "2024-10-15" },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            custom_source: "Quiz - MDP Leash Finder",
            profile: { data: { type: "profile", attributes: {
              email: email, first_name: fname,
              properties: {
                quiz_result:       S.result.primary.name,
                quiz_professional: S.ans.q1 ? S.ans.q1.lbl : "",
                quiz_dog_size:     S.ans.q2 ? S.ans.q2.lbl : "",
                quiz_behavior:     S.ans.q3 ? S.ans.q3.lbl : "",
                quiz_lifestyle:    S.ans.q4 ? S.ans.q4.lbl : "",
                quiz_training:     S.ans.q5 ? S.ans.q5.lbl : "",
                quiz_feel:         S.ans.q6 ? S.ans.q6.lbl : ""
              }
            } } }
          },
          relationships: { list: { data: { type: "list", id: KV_LIST } } }
        }
      })
    })
    .catch(function (e) { console.warn("[MDP Quiz] Klaviyo error:", e); })
    .finally(function () { goTo(8); });
  }

  /* ── OPEN / CLOSE ────────────────────────────────────────────────────── */
  function onKey(e) { if (e.key === "Escape") close(); }

  function open() {
    var overlay = document.getElementById("mdpModalOverlay");
    var blur = document.getElementById("mdpBlurOverlay");
    if (!overlay) return;
    S = freshState();
    S.opener = document.activeElement;
    S.scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = (-S.scrollY) + "px";
    document.body.classList.add("mdp-quiz-lock");
    overlay.classList.add("mdp-modal-open");
    if (blur) blur.classList.add("mdp-blur-active");
    document.addEventListener("keydown", onKey);
    track("QuizStarted", { brand: "Mountain Dog Products" });
    goTo(1);
    var wrap = overlay.querySelector(".mdp-wrap");
    if (wrap) wrap.focus({ preventScroll: true });
  }

  function close() {
    var overlay = document.getElementById("mdpModalOverlay");
    var blur = document.getElementById("mdpBlurOverlay");
    if (overlay) overlay.classList.remove("mdp-modal-open");
    if (blur) blur.classList.remove("mdp-blur-active");
    document.removeEventListener("keydown", onKey);
    document.body.classList.remove("mdp-quiz-lock");
    document.body.style.top = "";
    window.scrollTo(0, S.scrollY || 0);
    if (S.opener && typeof S.opener.focus === "function") { try { S.opener.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ── PUBLIC API (used by inline onclick attrs) ───────────────────────── */
  window.MDP = {
    open: open,
    close: close,
    start: function () { goTo(1); },

    pick: function (step, idx) {
      var q = QS[step - 1];
      S.ans[q.id] = q.opts[idx];
      renderQ(document.getElementById("mdpBody"), step);
      if (step < 6) setTimeout(function () { if (S.step === step) MDP.next(); }, AUTO_ADVANCE_MS);
      else track("QuizStepCompleted", { step: step, answer: q.opts[idx].lbl });
    },

    next: function () {
      var ans = S.ans["q" + S.step];
      if (S.step >= 1 && S.step <= 6 && !ans) return;
      if (S.step < 6) track("QuizStepCompleted", { step: S.step, answer: ans ? ans.lbl : "" });
      var nextStep = S.step + 1;
      if (nextStep === 6 && shouldSkipQ6()) { S.ans.q6 = null; nextStep = 7; }
      goTo(nextStep);
    },

    back: function () {
      var prev = S.step - 1;
      if (S.step === 7 && shouldSkipQ6()) prev = 5;
      if (prev >= 1) goTo(prev);
    },

    submitEmail: submitEmail,

    pickColor: function (idx) {
      var prod = S.result && S.result.primary;
      if (!prod || !prod.colors || !prod.colors[idx] || !prod.colors[idx].avail) return;
      S.selColor = prod.colors[idx];
      document.querySelectorAll(".mdp-sw").forEach(function (sw, i) {
        sw.classList.toggle("on", i === idx);
        sw.setAttribute("aria-pressed", i === idx ? "true" : "false");
      });
      var nameEl = document.getElementById("mdpColorName");
      if (nameEl) nameEl.textContent = S.selColor.name;
      if (prod.colors2) {
        // Re-check the traffic lead pair against the new hands-free colour.
        if (!S.selColor2 || !pairAvail(prod, S.selColor2.name)) S.selColor2 = defaultColor2(prod);
        var row2 = document.getElementById("mdpSwatches2");
        if (row2) row2.innerHTML = color2RowHtml(prod);
        var name2 = document.getElementById("mdpColorName2");
        if (name2) name2.textContent = S.selColor2 ? S.selColor2.name : "";
      }
      var imgEl = document.getElementById("mdpProdImg");
      if (imgEl) {
        var colorImg = prod.colorImages[S.selColor.name];
        var next = cdnResize(colorImg || prod.image || PH_IMG, 800);
        if (imgEl.src !== next) {
          imgEl.style.opacity = "0.6";
          imgEl.onload = function () { imgEl.style.opacity = "1"; };
          imgEl.src = next;
        }
      }
      refreshPrice();
    },

    pickColor2: function (idx) {
      var prod = S.result && S.result.primary;
      if (!prod || !prod.colors2 || !prod.colors2[idx] || !pairAvail(prod, prod.colors2[idx].name)) return;
      S.selColor2 = prod.colors2[idx];
      var row2 = document.getElementById("mdpSwatches2");
      if (row2) row2.innerHTML = color2RowHtml(prod);
      var name2 = document.getElementById("mdpColorName2");
      if (name2) name2.textContent = S.selColor2.name;
      refreshPrice();
    },

    pickLen: function (btn) {
      var len = btn && btn.getAttribute ? btn.getAttribute("data-len") : btn;
      S.selLen = len;
      document.querySelectorAll(".mdp-len-btn").forEach(function (b) {
        var on = b.getAttribute("data-len") === len;
        b.classList.toggle("on", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
      refreshPrice();
    },

    addToCart: function (btn, trafficOverride) {
      var prod = trafficOverride ? TRAFFIC : (S.result && S.result.primary);
      if (!prod || btn.disabled) return;
      var idle = trafficOverride ? "Add Traffic Lead to My Order →" : "Add to Cart →";
      btn.disabled = true;
      btn.classList.remove("added");
      btn.textContent = "Adding...";
      setMsg(btn, "", false);
      fetchVariantId(prod, function (variantId, reason) {
        if (!variantId) { explainFailure(btn, prod, reason, idle); return; }
        doCartAdd(btn, variantId, prod, idle);
      });
    },

    addBackupClip: function (btn) {
      if (btn.disabled) return;
      var idle = "Add Backup Clip to My Order →";
      btn.disabled = true;
      btn.textContent = "Adding...";
      setMsg(btn, "", false);
      fetchVariantId(BACKUP_CLIP, function (variantId, reason) {
        if (!variantId) { explainFailure(btn, BACKUP_CLIP, reason, idle); return; }
        doCartAdd(btn, variantId, BACKUP_CLIP, idle);
      });
    },

    handleOverlayClick: function (e) {
      if (e.target === document.getElementById("mdpModalOverlay")) close();
    },

    restart: function () { S = freshState(); close(); },

    openCart: function (e) {
      if (e && e.preventDefault) e.preventDefault();
      viewCart();
    }
  };
})();
